import React, { useState, useEffect } from "react";
import styled from "styled-components";
import axios from "axios";
import Permission from "./Permission";

const OwnesiteUrl = () => {
  const [externalSiteUrl, setExternalSiteUrl] = useState("");
  const [consentScrape, setConsentScrape] = useState(true);
  const [consentMerchantPage, setConsentMerchantPage] = useState(true);
  const [hasExternalSite, setHasExternalSite] = useState(true);
  const [storeName, setStoreName] = useState("");
  const [pageSlug, setPageSlug] = useState("");
  const [permission, setPermission] = useState(true);

  // ✅ Auto-generate slug when storeName changes
  // useEffect(() => {
  //   if (storeName) {
  //     setPageSlug(storeName.trim().toLowerCase().replace(/\s+/g, "-"));
  //   }
  // }, [storeName]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Ensure URL starts with http/https
    let finalUrl = externalSiteUrl.trim();
    if (!/^https?:\/\//i.test(finalUrl)) {
      finalUrl = "https://" + finalUrl;
    }

    try {
      const res = await axios.post(
        "https://api.bakpoket.com/api/merchant/preferences/upsert",
        {
          hasExternalSite,
          externalSiteUrl: finalUrl,
          consentScrape,
          consentMerchantPage,
          storeName,
          pageSlug,
        }
      );

      // console.log("Response:", res.data);
      alert("Store URL uploaded successfully!");
      setPermission(false);

      // reset fields
      setExternalSiteUrl("");
      setStoreName("");
      setPageSlug("");
    } catch (err) {
      console.error("Upload error:", err);
      alert("Upload failed.");
    }
  };

  return (
    <Wrapper>
      {permission ? (
        <Card>
          <h2>Enter Your Site Url</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Enter Store Name"
              value={storeName}
              required
              onChange={(e) => setStoreName(e.target.value)}
            />
            <input
              type="text"
              placeholder="Slug "
              value={pageSlug}
              required
              onChange={(e) => setPageSlug(e.target.value)}
            />
            <input
              type="text"
              placeholder="Enter Site URL"
              value={externalSiteUrl}
              required
              onChange={(e) => setExternalSiteUrl(e.target.value)}
            />
            <button type="submit">Submit</button>
          </form>
        </Card>
      ) : (
        <Permission />
      )}
    </Wrapper>
  );
};

export default OwnesiteUrl;

// ✅ Wrapper styles
const Wrapper = styled.section`
  width: 100%;
  max-width: 1280px;
  margin: 2% auto;
  padding: 30px;
  border-radius: 15px;

  @media (max-width: 974px) {
    padding: 15px;
  }
`;

// ✅ Card styles
const Card = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
  margin: auto;
  text-align: center;

  h2 {
    font-size: 22px;
    margin-bottom: 20px;
    color: #2a4157;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 10px;

    input[type="text"],
    input[type="url"] {
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 6px;
    }

    button {
      padding: 10px 15px;
      background-color: #ef4766;
      border: none;
      color: white;
      border-radius: 6px;
      cursor: pointer;
      font-weight: 600;
      transition: background 0.3s;

      &:hover {
        background-color: #d63c5b;
      }
    }
  }

  @media (max-width: 768px) {
    max-width: 220px;
    width: 85%;
    padding: 15px;

    h2 {
      font-size: 16px;
    }

    button {
      font-size: 12px;
      padding: 8px 12px;
    }

    input[type="text"],
    input[type="url"] {
      padding: 6px;
      font-size: 11px;
    }
  }
`;
